export default __webpack_public_path__ + "static/media/orange.52c14943.svg";